
import "./ServiceInvoiceTable.scss";
import { useTranslation } from "react-i18next";

const InvoiceTable = ({ columns, rows }) => {
    const { t } = useTranslation();
    if (!rows || rows.length === 0) {
        return <p>   {t("global:serviceInvoiceTable.empty")}</p>;
    }

    return (
        <table className="invoiceTable" >
            <thead>
                <tr>
                    {columns.map(col => (
                        <th key={col.key}>
                            {col.label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, index) => (
                    <tr
                        key={row.id}
                        className={`${index % 2 === 1 ? 'greyRow' : null} `}
                    >
                        {columns.map(col => (
                            <td key={col.key} >
                                {row[col.key]}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default InvoiceTable;